import { createReducer } from '@reduxjs/toolkit';
import { getAllCitiesAction } from './actions';

//reducer
const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(getAllCitiesAction, (state, action) => {
    state.list = action.payload;
  })
);
